import './client-list.scss'

import styled from '@emotion/styled'
import clsx from 'clsx'

import { ApiDfm } from '../../../api/_legacy/generated-api'
import { useClientsLayout } from '../clients-layout-provider'
import { BusinessUnit, Client } from '../types'

type BusinessUnitsListProps = {
  businessUnits: BusinessUnit[]
  onClickBusinessUnit: (businessUnitId: string) => void
  selectedBusinessUnit?: BusinessUnit
}

function BusinessUnitsList({
  businessUnits,
  onClickBusinessUnit,
  selectedBusinessUnit
}: BusinessUnitsListProps) {
  return (
    <ul className="business-unit-list">
      {businessUnits.map(bu => (
        <li
          key={bu.businessUnitId}
          className={clsx({
            selected:
              selectedBusinessUnit && selectedBusinessUnit.businessUnitId === bu.businessUnitId
          })}
        >
          <div
            className="business-unit-name-wrapper"
            role="button"
            tabIndex={0}
            onClick={() => onClickBusinessUnit(bu.businessUnitId)}
          >
            <div className="business-unit-name">{bu.businessUnitName}</div>
            <div className="business-unit-competency">{bu.competency}</div>
          </div>
        </li>
      ))}
    </ul>
  )
}

export type Props = {
  isExpanded?: boolean
  isSelected: boolean
  item: Client | ApiDfm
  onClickBusinessUnit: (businessUnitId: string) => void
  onClickItem: () => void
  selectedBusinessUnit?: BusinessUnit
}

const StyledListItem = styled.li<{ isPortfolioManagerScreen: boolean }>`
  ${({ isPortfolioManagerScreen }) =>
    isPortfolioManagerScreen &&
    `
    &::before {
      content: '' !important;
    }
  `}
`

export function ClientItem({
  isExpanded,
  isSelected,
  item,
  onClickBusinessUnit,
  onClickItem,
  selectedBusinessUnit
}: Props) {
  const { isPortfolioManagerScreen } = useClientsLayout()

  return (
    <StyledListItem
      className={clsx('client-item', {
        expanded: isExpanded,
        selected: isSelected
      })}
      isPortfolioManagerScreen={isPortfolioManagerScreen}
    >
      <div className="client-name-wrapper" role="button" tabIndex={0} onClick={onClickItem}>
        <div className="name">
          {isPortfolioManagerScreen ? (item as ApiDfm).dfmName : (item as Client).clientName}
        </div>
        {isPortfolioManagerScreen && <div className="type">{(item as Client).clientType}</div>}
      </div>
      {isExpanded && (
        <BusinessUnitsList
          businessUnits={(item as Client).businessUnits}
          selectedBusinessUnit={selectedBusinessUnit}
          onClickBusinessUnit={onClickBusinessUnit}
        />
      )}
    </StyledListItem>
  )
}
